"use strict";

import angular from "angular";

angular.module("nucont.accounting.group", ["nucont.shared"]);
require("./group.routes");
require("./dashboards/dashboards.routes");
require("./monitoring/group-monitoring.routes");
require("./monitoring/group-monitoring-config.routes");
require("./demonstrations/group-demonstations.routes");
require("./demonstrations/financial/financial-demonstrations.routes");
require("./demonstrations/financial/financial-dre.routes");
require("./demonstrations/accounting/accounting-demonstrations.routes");
require("./demonstrations/accounting/accounting-dre.routes");
require("./demonstrations/accounting/accounting-balance.routes");
require("./demonstrations/accounting/accounting-balance-sheet.routes");
require("./customization/group-customization.routes");
require("./scenarios/group-scenarios.routes");
require("./planning/group-planning.routes");
require("./reports/reports.routes");
require("./showtime/group-showtime.routes");
